export const FRAGMENT_CORE = `
fragment fragmentCore on Test {
  _id
}
`

export const FRAGMENT_USER_PROFILE_CORE = `
fragment fragmentUserProfileCore on User {
  _id
  name
  email
  profile_image {
    _id
    url
    created_at
    mime
  }
  created_at
  updated_at
}
`

export const FRAGMENT_COMPANY_PROFILE_CORE = `
fragment fragmentCompanyProfileCore on Company {
  _id
  name
  email
  telephone
  description
  created_at
  profile_image {
    url
  }
  url
}
`

export const FRAGMENT_LOCATION_CORE = `
fragment fragmentLocationCore on Location {
  _id
  name
  telephone
  address
  geo_location {
    lat
    lng
  }
  regionals {
    name
    level
    short_code
  }
  category {
    name
    short_code
  }
}
`

export const FRAGMENT_NEWS_CORE = `
fragment fragmentNewsCore on NewsPost {
  _id
  company {
    _id
    name
  }
  owner {
    _id
    name
    profile_image {
      _id
      url
      created_at
      mime
    }
    created_at
    updated_at
  }
  posters {
    _id
    url
  }
  category {
    name
    parent {
      name
      order
      short_code
    }
    order
    short_code
  }
  keywords {
    name
    short_code
    order
    parent {
      name
      order
      short_code
    }
  }
  tags {
    name
  }
  posters {
    _id
    url
    mime
  }
  locations {
    _id
    name
    telephone
    address
    geo_location {
      lat
      lng
    }
    regionals {
      name
      level
      short_code
    }
    category {
      name
      short_code
    }
  }
  stats {
    views
  }
  meta {
    limited {
      voucher {
        name
        order
        short_code
      }
      artist {
        name
        order
        short_code
      }
    }
    care {
      name
      order
      short_code
    }
    age {
      name
      order
      short_code
    }
    gender {
      name
      order
      short_code
    }
  }
  title
  description
  url
  is_pause
  is_published
  is_banned
  promote_start_at
  promote_end_at
  publish_at
  created_at
  updated_at
}
`

export const FRAGMENT_NEWS_LIST_CORE = `
fragment fragmentNewsListCore on NewsPost {
  _id
  posters {
    _id
    url
  }
  locations {
    regionals {
      name
      level
      short_code
    }
  }
  title
  is_pause
  is_published
  is_banned
  promote_start_at
  promote_end_at
  created_at
  stats {
    views
  }
}
`